import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TroubleshootingService extends DataService {

  constructor(http: HttpClient,  private localHttp: HttpClient) { 
    super('troubleshooting', http);
  }

  getAll() {
    return this.localHttp.get(this.url + '?filter[order]=sn asc');
  }
}
